import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faFolder,
  faFileAlt,
  faFileUpload,
  faCog,
  faUserCog,
  faFileInvoice,
  faChevronDown,
  faChevronRight,
  faCreditCard,
  faMoneyBill,
  faNetworkWired,
  faPercentage,
  faUserFriends,
  faShieldAlt,
  faKey,
} from "@fortawesome/free-solid-svg-icons";
import { motion, AnimatePresence } from "framer-motion";

const SidebarMain = ({ isOpen, onExpandSidebar }) => {
  const [openMenus, setOpenMenus] = useState({});

  const toggleMenu = (menuId) => {
    setOpenMenus((prev) => {
      const newState = { ...prev };
      const isCurrentlyOpen = newState[menuId];

      if (isCurrentlyOpen) {
        Object.keys(newState).forEach((key) => {
          if (key === menuId || key.startsWith(`${menuId}-`)) {
            newState[key] = false;
          }
        });
      } else {
        Object.keys(newState).forEach((key) => {
          if (
            key !== menuId &&
            !key.startsWith(`${menuId}-`) &&
            !menuId.startsWith(`${key}-`)
          ) {
            newState[key] = false;
          }
        });
        newState[menuId] = true;
      }
      return newState;
    });

    if (!isOpen) {
      onExpandSidebar();
    }
  };

  const navItems = [
    {
      id: "dashboard",
      to: "/dashboard",
      title: "Dashboard",
      icon: faChartLine,
      color: "from-blue-500 to-indigo-600",
      iconColor: "text-blue-600",
    },
      // { path: "/card-replacement-fee/upload-card-replacement-fee", element: <UploadCardFee  />, permission: "access_page" },
      // { path: "/card-replacement-fee/upload-card-replacement-fee-history", element: <UploadCardFeeHistory  />, permission: "access_page" },
      // { path: "/card-replacement-fee/processed", element: <CardFeeProcessedHistory />, permission: "access_page" },
    {
      id: "card-replacement-fee",
      title: "Upload Card Replacement Fee (CRF)",
      icon: faCreditCard,
      color: "from-green-500 to-emerald-600",
      iconColor: "text-green-600",
      subItems: [
        {
          id: "card-replacement-fee-upload-card-replacement-fee",
          to: "/card-replacement-fee/upload-card-replacement-fee",
          title: "Upload File(s)",
          icon: faFileUpload,
          iconColor: "text-green-500",
        },
        {
          id: "upload-card-replacement-fee-history",
          to: "/card-replacement-fee/upload-card-replacement-fee-history",
          title: "Uploaded File History",
          icon: faFileUpload,
          iconColor: "text-green-500",
        },
        {
          id: "upload-card-replacement-fee-processed",
          to: "/card-replacement-fee/processed",
          title: "Uploaded Data Processed List",
          icon: faFolder,
          iconColor: "text-green-500",
        },
      ],
    },
    {
      id: "upload-admin-fee",
      title: "Upload Admin Fee (AF)",
      icon: faMoneyBill,
      color: "from-teal-500 to-cyan-600",
      iconColor: "text-teal-600",
      subItems: [
        {
          id: "upload-admin-fee",
          to: "/admin-fee/upload-admin-fee",
          title: "Upload File(s)",
          icon: faFileUpload,
          iconColor: "text-teal-500",
        },
        {
          id: "upload-card-fee-history",
          to: "/admin-fee/upload-admin-fee-history",
          title: "Uploaded File History",
          icon: faFileUpload,
          iconColor: "text-teal-500",
        },
        {
          id: "upload-card-fee-processed",
          to: "/admin-fee/processed",
          title: "Uploaded Data Processed List",
          icon: faFolder,
          iconColor: "text-teal-500",
        },
      ],
    },
    {
      id: "billing",
      title: "Billing",
      icon: faFileInvoice,
      color: "from-purple-500 to-violet-600",
      iconColor: "text-purple-600",
      subItems: [
        {
          id: "network-access-fee",
          title: "NAF (Generate)",
          to: "/billing/network-access-fee",
          icon: faNetworkWired,
          iconColor: "text-purple-500",
        },
        {
          id: "network-access-fee-billed",
          title: "NAF (Billed)",
          to: "/billing/network-access-fee-billed",
          icon: faNetworkWired,
          iconColor: "text-purple-500",
        },
        {
          id: "admin-fee",
          to: "/billing/admin-fee",
          title: "Admin Fee (Generate)",
          icon: faMoneyBill,
          iconColor: "text-purple-500",
        },
        {
          id: "admin-fee-billed",
          to: "/billing/admin-fee-billed",
          title: "Admin Fee (Billed)",
          icon: faMoneyBill,
          iconColor: "text-purple-500",
        },
        {
          id: "card-fee",
          title: "Card Fee",
          icon: faCreditCard,
          iconColor: "text-purple-500",
          subItems: [
            {
              id: "card-printing-fee",
              to: "/billing/card-printing-fee",
              title: "CPF (Generate)",
              icon: faCreditCard,
              iconColor: "text-purple-400",
            },
            {
              id: "card-printing-fee-billed",
              to: "/billing/card-printing-fee-billed",
              title: "CPF (Billed)",
              icon: faCreditCard,
              iconColor: "text-purple-400",
            },
            {
              id: "card-replacement-fee",
              to: "/billing/card-replacement-fee",
              title: "CRF (Generate)",
              icon: faCreditCard,
              iconColor: "text-purple-400",
            },
            {
              id: "card-replacement-fee-billed",
              to: "/billing/card-replacement-fee-billed",
              title: "CRF (Billed)",
              icon: faCreditCard,
              iconColor: "text-purple-400",
            },
          ],
        },
        {
          id: "interest-fee",
          title: "Interest Fee (Generate)",
           to: "/billing/interest-fee",
          icon: faPercentage,
          iconColor: "text-purple-500",
        },
        {
          id: "interest-fee-billed",
          title: "Interest Fee (Billed)",
          to: "/billing/interest-fee-billed",
          icon: faPercentage,
          iconColor: "text-purple-500",
        },
      ],
    },
    {
      id: "corporate-setup",
      title: "Setup Billing Fees",
      icon: faCreditCard,
      color: "from-pink-500 to-rose-600",
      iconColor: "text-pink-600",
      subItems: [
        {
          id: "settings",
          to: "/corporate-settings",
          title: "Setup Billing Fees",
          icon: faCog,
          iconColor: "text-pink-500",
        },
        {
          id: "view-settings",
          to: "/corporate-view-settings",
          title: "View Billing Fees",
          icon: faCog,
          iconColor: "text-pink-500",
        },
      ],
    },

    {
      id: "collection",
      title: "Collections",
      icon: faFileInvoice,
      color: "from-orange-500 to-amber-600",
      iconColor: "text-orange-600",
      subItems: [
        {
          id: "collection-dashboard",
          to: "/collections/dashboard",
          title: "Dashboard",
          icon: faFileInvoice,
          iconColor: "text-orange-600",
        },
        {
          id: "collection-list",
          to: "/collections/list",
          title: "Collections List",
          icon: faFileInvoice,
          iconColor: "text-orange-600",
        },
      ],
    },

    // {
    //   id: "collection",
    //   to: "/collections",
    //   title: "Collections",
    //   icon: faFileInvoice,
    //   color: "from-orange-500 to-amber-600",
    //   iconColor: "text-orange-600",
    // },

    {
      id: "reports",
      to: "/reports",
      title: "Reports",
      icon: faFileAlt,
      color: "from-red-500 to-rose-600",
      iconColor: "text-red-600",
    },
    {
      id: "user-management",
      title: "User Management",
      icon: faUserCog,
      color: "from-indigo-500 to-blue-600",
      iconColor: "text-indigo-600",
      subItems: [
        {
          id: "users",
          to: "/users",
          title: "Users Management",
          icon: faUserFriends,
          iconColor: "text-indigo-500",
        },
        {
          id: "roles",
          to: "/roles",
          title: "Roles Management",
          icon: faShieldAlt,
          iconColor: "text-indigo-500",
        },
        {
          id: "permissions",
          to: "/permissions",
          title: "Permissions Management",
          icon: faKey,
          iconColor: "text-indigo-500",
        },
      ],
    },
  ];

  const subMenuVariants = {
    closed: {
      height: 0,
      opacity: 0,
      transition: {
        duration: 0.3,
        ease: "easeOut",
      },
    },
    open: {
      height: "auto",
      opacity: 1,
      transition: {
        duration: 0.3,
        ease: "easeIn",
      },
    },
  };

  const renderMenuItem = (item, level = 0, parentId = "") => {
    const hasSubItems = item.subItems && item.subItems.length > 0;
    const menuId = parentId ? `${parentId}-${item.id}` : item.id;
    const isSubMenuOpen = openMenus[menuId];

    return (
      <div key={menuId} className="relative">
        {item.to ? (
          <NavLink
            // to={item.to}
            // className={({ isActive }) => `
            //   flex items-center w-full py-3 px-4 rounded-xl transition-all duration-300
            //   ${
            //     isActive
            //       ? `bg-gradient-to-r ${item.color} text-white shadow-md`
            //       : "text-gray-700 hover:bg-gray-100 hover:shadow-sm"
            //   }
            //   ${isOpen ? `pl-${4 + level * 4}` : "justify-center pl-4"}
            // `}
            // title={item.title}
            to={item.to}
  className={({ isActive }) => {
    const baseColor = item.color || parentId.includes("card-replacement-fee")
      ? "from-green-500 to-emerald-600"
      : parentId.includes("upload-admin-fee")
      ? "from-teal-500 to-cyan-600"
      : parentId.includes("billing")
      ? "from-purple-500 to-violet-600"
      : parentId.includes("corporate-setup")
      ? "from-pink-500 to-rose-600"
      : "from-gray-400 to-gray-600";

    return `
      flex items-center w-full py-3 px-4 rounded-xl transition-all duration-300
      ${
        isActive
          ? `bg-gradient-to-r ${baseColor} text-white shadow-md`
          : "text-gray-700 hover:bg-gray-100 hover:shadow-sm"
      }
      ${isOpen ? `pl-${4 + level * 4}` : "justify-center pl-4"}
    `;
  }}
  title={item.title}
          >
            {({ isActive }) => (
              <>
                {item.icon && (
                  <FontAwesomeIcon
                    icon={item.icon}
                    className={`
                      text-lg min-w-[22px] transition-colors duration-300
                      ${isActive ? "text-white" : item.iconColor || "text-gray-600"}
                    `}
                  />
                )}
                {isOpen && (
                  <span
                    className={`
                      ml-3 text-sm font-semibold flex-1 truncate
                      ${level > 0 ? "text-gray-700" : isActive ? "text-white" : "text-gray-800"}
                    `}
                  >
                    {item.title}
                  </span>
                )}
              </>
            )}
          </NavLink>
        ) : (
          // <div
          //   className={`
          //     flex items-center w-full py-3 px-4 rounded-xl transition-all duration-300 cursor-pointer
          //     ${isOpen ? "justify-start" : "justify-center"}
          //     ${hasSubItems ? `hover:bg-gradient-to-r ${item.color} hover:text-white hover:shadow-sm` : ""}
          //     ${`pl-${4 + level * 4}`}
          //   `}
          //   onClick={() => {
          //     if (hasSubItems) {
          //       toggleMenu(menuId);
          //     }
          //   }}
          // >
          <div
  className={`
    flex items-center w-full py-3 px-4 rounded-xl transition-all duration-300 cursor-pointer
    ${isOpen ? "justify-start" : "justify-center"}
    ${isSubMenuOpen ? `bg-gradient-to-r ${item.color} text-white shadow-md` : ""}
    ${!isSubMenuOpen && hasSubItems ? `hover:bg-gradient-to-r ${item.color} hover:text-white hover:shadow-sm` : ""}
    ${`pl-${4 + level * 4}`}
  `}
  onClick={() => {
    if (hasSubItems) {
      toggleMenu(menuId);
    }
  }}
>
            {item.icon && (
              <FontAwesomeIcon
                icon={item.icon}
                className={`
                  text-lg min-w-[22px] transition-colors duration-300
                  ${item.iconColor || "text-gray-600"}
                `}
              />
            )}
            {isOpen && (
              <span
                className={`
                  ml-3 text-sm font-semibold flex-1 truncate
                  ${level > 0 ? "text-gray-700" : "text-gray-800"}
                `}
              >
                {item.title}
              </span>
            )}
            {hasSubItems && isOpen && (
              <FontAwesomeIcon
                icon={isSubMenuOpen ? faChevronDown : faChevronRight}
                className="ml-auto text-xs text-gray-500 transition-transform duration-300 min-w-[12px]"
              />
            )}
          </div>
        )}

        {hasSubItems && isOpen && (
          <AnimatePresence>
            {isSubMenuOpen && (
              <motion.div
                initial="closed"
                animate="open"
                exit="closed"
                variants={subMenuVariants}
                className="overflow-hidden space-y-1 mt-1"
              >
                {item.subItems.map((subItem) =>
                  renderMenuItem(subItem, level + 1, menuId)
                )}
              </motion.div>
            )}
          </AnimatePresence>
        )}
      </div>
    );
  };

  return (
    <nav className={`space-y-2 p-4 bg-gradient-to-b from-gray-50 to-gray-100 shadow-lg rounded-xl ${isOpen ? "w-72" : "w-20"} transition-all duration-300`}>
      {navItems.map((item) => renderMenuItem(item))}
    </nav>
  );
};

export default SidebarMain;